<template>
  <div>
    <div class="Product">
      <div class="product_info">
        <div class="Product_mat">
          <div class="Product_mat_info">
            <div class="Product_mat_info_cn">产品介绍</div>
            <div class="Product_mat_info_en">Product Introduction</div>
          </div>
        </div>
        <div>
          <img src="../../assets/img/home/everybg.png" width="100%" alt="" />
        </div>
      </div>

      <div class="product_top_btn">
        <div class="product_top_btn_div">
          <div class="DP">
            <button
              @click="tabChange"
              class="Product_JCYY_btn"
              :class="{ Solution_JCYY_active: tab == 1 }"
              data-id="1"
            >
              CAD可视化输出插件
            </button>
            <button
              @click="tabChange"
              class="Product_JCYY_btn"
              :class="{ Solution_JCYY_active: tab == 2 }"
              data-id="2"
            >
              可视化查看工具
            </button>
            <button
              @click="tabChange"
              class="Product_JCYY_btn"
              :class="{ Solution_JCYY_active: tab == 3 }"
              data-id="3"
            >
              批量处理
            </button>
            <!-- <button
              @click="tabChange"
              class="Product_JCYY_btn"
              :class="{ Solution_JCYY_active: tab == 4 }"
              data-id="4"
            >
              三维工艺
            </button> -->
          </div>
        </div>
      </div>
      <div class="product-one" v-show="tab == 1">
        <div class="product-light">
          <div class="light-content">
            <div class="left">
              <h1 class="title">CAD可视化输出</h1>
              <div class="message">
                CAD端插件输出可视化文件，更简单、快捷、高效、轻量化后保持模型完整性。
              </div>
            </div>
            <div class="right">
              <img src="../../assets/img/product/light.png" alt="" />
            </div>
          </div>
        </div>
        <div class="product-features">
          <div class="features-title">产品特点</div>
          <div class="features-box">
            <div
              class="features-item"
              v-for="(item, index) of featureList"
              :key="index"
            >
              <img :src="getImagePath(item.url)" />
              <div class="title">
                {{ item.title }}
              </div>
              <div class="content">
                {{ item.message }}
              </div>
            </div>
          </div>
        </div>
        <div class="product-function">
          <div class="function-title">主要功能</div>
          <div class="function-content">
            <div class="swiper">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(item, index) in functionList"
                  :key="index"
                >
                  <div class="left">
                    <img :src="getImagePath(item.image)" alt="" />
                  </div>
                  <div class="right">
                    <div class="right-box">
                      <div class="title">
                        <img
                          src="../../assets/img/product/triangle.png"
                          alt=""
                        />
                        <span> {{ item.title }} </span>
                      </div>
                      <div class="text">
                        <span> {{ item.text }} </span>
                      </div>
                      <div class="content">
                        <div
                          v-for="(paragraph, value) in item.paragraphs"
                          :key="value"
                        >
                          {{ paragraph }}
                        </div>
                      </div>
                      <div class="button" v-show="item.isBotton">
                        <el-button type="primary" @click="dialogVisible = true"
                          >下载试用</el-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="swiper-pagination"></div>
              <!-- <div class="function-bottons">
                <div class="button-prev iconfont icon-zuojiantou"></div>
                <div class="button-next iconfont icon-youjiantou1"></div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="product-value">
          <div class="value-title">产品价值</div>
          <div class="value-content">
            <div
              class="value-box"
              v-for="(item, index) of productList"
              :key="index"
            >
              <div class="left">
                <img :src="getImagePath(item.url)" alt="" />
              </div>
              <div class="right">
                <div class="content">{{ item.content }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="product-two" v-show="tab == 2">
        <div class="product-light">
          <div class="light-content">
            <div class="left">
              <h1 class="title">可视化查看工具</h1>
              <div class="message">
                加载自主输出(*PIV)模型格式，一款跨平台、跨浏览器、跨终端设备的可视化工具。
              </div>
              <div class="button-box">
                <el-button type="primary" @click="tryNow">立即体验</el-button>
              </div>
            </div>
            <div class="right">
              <img src="../../assets/img/product/visualization.png" alt="" />
            </div>
          </div>
        </div>
        <div class="product-features">
          <div class="features-title">产品特点</div>
          <div class="features-box">
            <div
              class="features-item"
              v-for="(item, index) of featureArray"
              :key="index"
            >
              <img :src="getImagePath(item.url)" />
              <div class="title">
                {{ item.title }}
              </div>
              <div class="content">
                {{ item.message }}
              </div>
            </div>
          </div>
        </div>
        <div class="product-function">
          <div class="main-title">主要功能</div>
          <div class="main-content">
            <div class="swiper">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(item, index) in functionArray"
                  :key="index"
                >
                  <div class="left">
                    <img :src="getImagePath(item.image)" alt="" />
                  </div>
                  <div class="right">
                    <div class="right-box">
                      <div class="title">
                        <img
                          src="../../assets/img/product/triangle.png"
                          alt=""
                        />
                        <span> {{ item.title }} </span>
                      </div>
                      <div class="function">
                        <div
                          v-for="(paragraph, value) in item.paragraphs"
                          :key="value"
                        >
                          {{ paragraph }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="swiper-pagination"></div>
              <!-- <div class="function-bottons">
                <div class="button-prev iconfont icon-zuojiantou"></div>
                <div class="button-next iconfont icon-youjiantou1"></div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="product-value">
          <div class="value-title">产品价值</div>
          <div class="value-content">
            <div
              class="value-box"
              v-for="(item, index) of productArray"
              :key="index"
            >
              <div class="left">
                <img :src="getImagePath(item.url)" alt="" />
              </div>
              <div class="right">
                <div class="content">{{ item.content }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="product-three" v-show="tab == 3">
        <div class="product-light">
          <div class="light-content">
            <div class="left">
              <h1 class="title">批量处理工具</h1>
              <div class="message">
                支持多种CAD模型格式批量上传轻量化输出，Task机监听分配任务，Worker机接收任务处理。
              </div>
            </div>
            <div class="right">
              <img src="../../assets/img/product/batch.png" alt="" />
            </div>
          </div>
        </div>
        <div class="product-features">
          <div class="features-title">产品特点</div>
          <div class="features-box">
            <div
              class="batch-item"
              v-for="(item, index) of batchList"
              :key="index"
            >
              <img :src="getImagePath(item.url)" />
              <div class="title">
                {{ item.title }}
              </div>
              <div class="content">
                {{ item.message }}
              </div>
            </div>
          </div>
        </div>
        <div class="product-function">
          <div class="function-title">主要功能</div>
          <div class="function-content">
            <div class="swiper">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(item, index) in taskArray"
                  :key="index"
                >
                  <div class="left">
                    <img :src="getImagePath(item.image)" alt="" />
                  </div>
                  <div class="right">
                    <div class="right-box">
                      <div class="title">
                        <img
                          src="../../assets/img/product/triangle.png"
                          alt=""
                        />
                        <span> {{ item.title }} </span>
                      </div>
                      <div class="function">
                        <div
                          v-for="(paragraph, value) in item.paragraphs"
                          :key="value"
                        >
                          {{ paragraph }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="swiper-pagination"></div>
              <!-- <div class="function-bottons">
                <div class="button-prev iconfont icon-zuojiantou"></div>
                <div class="button-next iconfont icon-youjiantou1"></div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="product-value">
          <div class="value-title">产品价值</div>
          <div class="value-content">
            <div
              class="value-box"
              v-for="(item, index) of batchValue"
              :key="index"
            >
              <div class="left">
                <img :src="getImagePath(item.url)" alt="" />
              </div>
              <div class="right">
                <div class="content">{{ item.content }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="product-four" v-show="tab == 4">
        <div class="product-light">
          <div class="light-content">
            <div class="left">
              <h1 class="title">三维工艺</h1>
              <div class="message">
                Creo
                二次开发技术，为工艺设计人员提供一套完整的全三维数字化设计工具。
              </div>
              <div class="button-box">
                <el-button type="primary">下载详情</el-button>
              </div>
            </div>
            <div class="right">
              <img src="../../assets/img/product/craft.png" alt="" />
            </div>
          </div>
        </div>
        <div class="product-features">
          <div class="features-title">产品特点</div>
          <div class="features-box">
            <div
              class="process-item"
              v-for="(item, index) of featureData"
              :key="index"
            >
              <img :src="getImagePath(item.url)" />
              <div class="title">
                {{ item.title }}
              </div>
              <div class="content">
                {{ item.message }}
              </div>
            </div>
          </div>
        </div>
        <div class="product-function">
          <div class="function-title">主要功能</div>
          <div class="function-content">
            <div class="swiper">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(item, index) in functionData"
                  :key="index"
                >
                  <div class="left">
                    <img :src="getImagePath(item.image)" alt="" />
                  </div>
                  <div class="right">
                    <div class="content-box">
                      <div class="title">
                        <img
                          src="../../assets/img/product/triangle.png"
                          alt=""
                        />
                        <span> {{ item.title }} </span>
                      </div>
                      <div class="text">
                        <span> {{ item.text }} </span>
                      </div>
                      <div class="content">
                        <div
                          v-for="(paragraph, value) in item.paragraphs"
                          :key="value"
                        >
                          {{ paragraph }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="swiper-pagination"></div>
              <!-- <div class="function-bottons">
                <div class="button-prev iconfont icon-zuojiantou"></div>
                <div class="button-next iconfont icon-youjiantou1"></div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="product-value">
          <div class="value-title">产品价值</div>
          <div class="value-content">
            <div
              class="value-box"
              v-for="(item, index) of productData"
              :key="index"
            >
              <div class="left">
                <img :src="getImagePath(item.url)" alt="" />
              </div>
              <div class="right">
                <div class="content">{{ item.content }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="下载试用"
      :visible.sync="dialogVisible"
      close-on-click-modal
      width="50%"
      @close="handleClose"
    >
      <el-table
        :data="tableData"
        v-loading="loading"
        style="width: 100%;font-size: 18px;"
      >
        <el-table-column label="名称">
          <template slot-scope="scope">
            <div class="name-wrapper">
              <span class="iconfont icon-yasuobao image"></span>
              <span class="name">{{ scope.row.filename }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click.native.prevent="downLoad(scope.row.filename)"
            >
              <div class="download-content">
                <span class="iconfont icon-xiazai downLoad-text"></span>
                <span class="downLoad-name">下载</span>
              </div>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import Swiper from "swiper";
import { Navigation, Mousewheel, Pagination } from "swiper/modules";
import "swiper/swiper.css";
import "swiper/modules/navigation.css";
import "swiper/modules/pagination.css";
import "swiper/modules/mousewheel.css";
Swiper.use([Navigation, Mousewheel, Pagination]);
export default {
  name: "product",
  data() {
    return {
      tab: 1,
      dialogVisible: false,
      featureList: [
        {
          title: "结构信息",
          url: require("../../assets/img/home/structure.png"),
          message: "保持与原始模型的几何外观、PMI、模型结构和属性等数据一致"
        },
        {
          title: "误差范围",
          url: require("../../assets/img/home/deviation.png"),
          message:
            "关键几何参数的提取，包括模型包围盒、面积、体积等，误差控制在99%以内"
        },
        {
          title: "压缩比",
          url: require("../../assets/img/home/compression.png"),
          message: "可达10-100倍的压缩比"
        },
        {
          title: "可控制",
          url: require("../../assets/img/home/control.png"),
          message:
            "输出可视化，控制精度数、弦高、角度、步长大小、金属性、粗糙度等参数"
        }
      ],
      featureArray: [
        {
          title: "可跨终端",
          url: require("../../assets/img/product/terminal.png"),
          message:
            "WebGL、Threejs开发的，无需插件的跨终端CAD可视化工具，支持平台：Windows、IOS、Android 支持终端：PC、平板、手机、电视大屏"
        },
        {
          title: "多浏览器",
          url: require("../../assets/img/product/browse.png"),
          message:
            "支持浏览器：Apple（Safari）、Google （Chrome）、Microsoft（Edge）、Mozilla（Firefox）"
        },
        {
          title: "三维交互",
          url: require("../../assets/img/product/three-dimension.png"),
          message:
            "包含基本交互、模型树结构、颜色、剖切、PMI注释、动画、渲染功能"
        },
        {
          title: "大装配",
          url: require("../../assets/img/product/assembly.png"),
          message:
            " 支持千万级面片、万级部件的超大规模装配模型的显示交互，可流畅操作，无明显卡顿"
        }
      ],
      batchList: [
        {
          title: "完美配合",
          url: require("../../assets/img/product/cooperate.png"),
          message:
            "Task、Worker可部署在不同服务器，完美配合，完成监听、分配任务、接收任务完成转档、监听转档任务进度"
        },
        {
          title: "输出快",
          url: require("../../assets/img/product/output.png"),
          message:
            "可多台Worker机同时在线接收任务，转档速度快，大装配模型轻量化输出，每小时可自动输出上万个标准件"
        },
        {
          title: "自动化",
          url: require("../../assets/img/product/automation.png"),
          message: "无人工作站，不需要手动操作，自动监控输出"
        }
      ],
      featureData: [
        {
          title: "无缝衔接",
          url: require("../../assets/img/product/seamless.png"),
          message: "将设计模型直接转换为工艺模型，实现工艺与设计无缝衔接"
        },
        {
          title: "设计和发布",
          url: require("../../assets/img/product/public.png"),
          message:
            "独特的工艺文件设计和发布方式，包含零件和装配工艺，方便设计过程和工艺查看"
        },
        {
          title: "标注信息",
          url: require("../../assets/img/product/annotation.png"),
          message:
            "在三维工件上直接标注PMI信息，实现强大的标注功能，清晰直观，方便查看"
        },
        {
          title: "仿真",
          url: require("../../assets/img/product/simulation.png"),
          message: "建立与工艺模型相关联的仿真，制作大型复杂的装配仿真"
        },
        {
          title: "自动化",
          url: require("../../assets/img/product/integration.png"),
          message: "发布兼容性好的仿真结果，无需其他软件支持，支持浏览器打开"
        }
      ],
      functionList: [
        {
          image: require("../../assets/img/product/plugin.png"),
          title: "输出PIV系列",
          text: "自定义输出可视化文件(*PIV)模型",
          paragraphs: [
            "精度控制包含默认粗糙、标准、高精、自定义，控制输出定点颜色、UV纹理坐标、曲线特征、轮廓线、注释、略缩图。",
            "CAD支持：Creo、CATIA、NX、SolidWorks、Inventor、SolidEdge；国产：中望3D、新迪天工CAD等。"
          ],
          isBotton: false
        },
        {
          image: require("../../assets/img/product/plugin1.png"),
          title: "输出GLTF系列",
          text: "输出可视化文件GLTF模型（免费试用）",
          paragraphs: [
            "GLTF跨平台格式Web上的3D对象标准，CAD模型输出仅包含装配结构和几何信息，可控制精度输出。",
            "CAD支持：Creo、CATIA、NX、SolidWorks、Inventor、SolidEdge。"
          ],
          isBotton: true
        }
      ],
      functionArray: [
        {
          image: require("../../assets/img/product/basic.gif"),
          title: "基本功能",
          paragraphs: [
            "可视化版本划分：简易版（Lite）、标准版（Standard）、专业版（Professional）、工艺版（Process）企业版（Enterprise）。",
            "基本画布和操作工具条：旋转、缩放、移动、视角切换、显示、隐含、半透明、线框渲染、动画播放（播放、暂停、顺序、逆序、控制速度）、工艺模型信息、工艺模型属性、装配模型分解、模型剖切。"
          ]
        },
        {
          image: require("../../assets/img/product/advanced.gif"),
          title: "高级功能",
          paragraphs: [
            "动画：允许增加简单的动画并能保存，比如延轴移动，绕轴旋转，定时循环。",
            "干涉检查：装配中检查两个模型的干涉情况，动画中检查干涉情况。",
            "模型比较：比较两个模型的差异。",
            "图层：按图层；过滤模型。",
            "测量：测量面、边参数。",
            "标注：电子章（戳记）。",
            "动画：循环播放，往返播放。"
          ]
        }
      ],
      taskArray: [
        {
          image: require("../../assets/img/product/TundraTask.png"),
          title: "Task机",
          paragraphs: [
            "提供Socket监听，允许Worker接入",
            "监听服务器上目录下模型对象",
            "将来可能需要直接读Server系统目录",
            "根据对象类型和接入Worker类型及状态分配转档任务",
            "监听转档进度，更新状态"
          ]
        },
        {
          image: require("../../assets/img/product/TundraWorker.png"),
          title: "Worker机",
          paragraphs: [
            "启动链接Task，注册可处理任务类型",
            "接收来自Task的任务，下载模型文件",
            "发送Adapter，完成转档",
            "更新转档状态",
            "上传转换结果"
          ]
        }
      ],
      functionData: [
        {
          image: require("../../assets/img/product/one.gif"),
          title: "工艺模型构建",
          paragraphs: [
            "在Creo设计环境中，以Creo自带的功能为基础，加入工艺设计模块；",
            "数据模型采用Creo设计模型，在原设计模型的基础上，重新生成备份文件即参考模型，以保证原设计模型的数据不会丢失；"
          ]
        },
        {
          image: require("../../assets/img/product/two.gif"),
          title: "工艺特征重建",
          paragraphs: [
            "零件工艺可以采用正向建模和逆向建模两种方式，对模型进行特征重建；",
            "逆向建模所生成的工艺毛坯模型，其数据与参考模型一致，从工艺模型进行还原，最终产生加工时所需要的毛坯件；",
            "正向建模是以毛坯件为基础，仿照现实加工方式，进行去材料操作，生成最终的工艺模型；"
          ]
        },
        {
          image: require("../../assets/img/product/three.gif"),
          title: "工艺规程设计",
          paragraphs: [
            "根据工艺要求设计产品的工艺规程树结构，按层次关系结构化组织工艺规程信息；",
            "根据所设计的工艺规程树，进行对应特征的包含，使每一个工序节点都能显示执行当前工序过后的模型；",
            "简单易操作的规程定制，使零部件构成更为清晰直观，可方便添加工步、工序详细信息，规程设计更为清晰。"
          ]
        },
        {
          image: require("../../assets/img/product/four.gif"),
          title: "工艺资源添加",
          paragraphs: [
            "工艺规程设计可以在工艺数据库中提取数据，保证工艺设计的标准化；",
            "工艺规程设计可以在数据库标准化数据的基础上，对特殊的加工进行工艺的调整，保证工艺设计的准确性；",
            "工艺节点包含工艺资源信息，可以填写相对应的工艺所需的信息，包括材料，工艺方法，方法参数等等；"
          ]
        },
        {
          image: require("../../assets/img/product/five.gif"),
          title: "工艺信息标注",
          paragraphs: [
            "三维工艺集成了湃睿科技独立研发的三维信息标注软件，在对公差、表面结构、基准等标注时，大大提高标注效率；",
            "可以添加国际通用的标准符号，对已标注的符号进行修饰，操作简易，方便操作人员快速可识别。"
          ]
        },
        {
          image: require("../../assets/img/product/six.gif"),
          title: "工艺仿真",
          paragraphs: [
            "利用Creo自带的强大的仿真功能，可以模拟零件的机加工时的装夹过程；",
            "可以模拟对应零件模型在机加工时，车刀的行进过程，同时形成刀路轨迹，模拟刀路运动。"
          ]
        },
        {
          image: require("../../assets/img/product/seven.gif"),
          title: "工艺结果发布",
          paragraphs: [
            "工艺结果发布直接生成html文件，直接在浏览器中查看，界面集成CreoView，可以查看任意角度的模型信息，交互性强；",
            "工艺发布结果按工序工步划分，条理清晰，可以查看对应工序工步的模型信息，标注信息以及在加工过程中的一些要求；",
            "工艺发布结果可以播放在Creo中实现的各种模拟仿真，界面清晰直观，可以把数据上传至数据库，方便查看修改。"
          ]
        }
      ],
      productList: [
        {
          url: require("../../assets/img/product/value1.png"),
          content:
            "提高计算效率：三维模型轻量化减少其数据量，可以提高计算效率，并让模型更好地适应不同场景和需求；"
        },
        {
          url: require("../../assets/img/product/value2.png"),
          content:
            "减少存储空间：三维模型轻量化减少其存储空间的占用，从而节省存储成本和提高系统性能；"
        },
        {
          url: require("../../assets/img/product/value3.png"),
          content:
            "加快渲染速度：三维模型轻量化可以降低模型的复杂度和大小，从而加快渲染速度；"
        },
        {
          url: require("../../assets/img/product/value4.png"),
          content:
            "优化用户体验：三维模型轻量化提高处理速度和性能，并让用户更加流畅地进行交互操作，从而优化用户体验；"
        }
      ],
      productArray: [
        {
          url: require("../../assets/img/product/terminal.png"),
          content:
            "可夸终端设备、多浏览器访问、操作简单但功能强大的可视化工具；"
        },
        {
          url: require("../../assets/img/product/effect.png"),
          content:
            "改善效率，降低成本，工程师随时随地可用移动端查看CAD模型，方便快捷；"
        },
        {
          url: require("../../assets/img/product/value3.png"),
          content:
            "超大模型轻松加载，支持千万级面片、万级部件的超大规模装配的3D模型轻量化，加载显示流畅，性能最优化；"
        }
      ],
      batchValue: [
        {
          url: require("../../assets/img/product/value4.png"),
          content:
            "提高模型转档效率，手动输出需要耗费大量时间和人力，批量转档快速执行，有效地提高模型装档效率；"
        },
        {
          url: require("../../assets/img/product/stable.png"),
          content: "数据可靠性和稳定性，自动转档过程记录转档进度，更新状态；"
        }
      ],
      tableData: [],
      loading: false,
      productData: [
        {
          url: require("../../assets/img/product/traditional.png"),
          content:
            "提高计算效率：三维模型轻量化减少其数据量，可以提高计算效率，并让模型更好地适应不同场景和需求；"
        },
        {
          url: require("../../assets/img/product/manuface.png"),
          content:
            "减少存储空间：三维模型轻量化减少其存储空间的占用，从而节省存储成本和提高系统性能；"
        },
        {
          url: require("../../assets/img/product/convenient.png"),
          content:
            "加快渲染速度：三维模型轻量化可以降低模型的复杂度和大小，从而加快渲染速度；"
        },
        {
          url: require("../../assets/img/product/time.png"),
          content:
            "优化用户体验：三维模型轻量化提高处理速度和性能，并让用户更加流畅地进行交互操作，从而优化用户体验；"
        }
      ]
    };
  },
  mounted() {
    let myTab = this.$route.query.view;
    if (myTab == "adapter") {
      this.tab = 1;
    }
    if (myTab == "viewer") {
      this.tab = 2;
    }
    if (myTab == "wgm") {
      this.tab = 3;
    }
    this.initSwiper();
    this.goFile();
  },
  created() {
    this.tab = 1;
    this.$emit("FootItem", true);
  },
  methods: {
    initSwiper() {
      this.swiper = new Swiper(".swiper", {
        mousewheel: true,
        pagination: {
          el: ".swiper-pagination",
          type: "fraction"
        },
        navigation: {
          nextEl: ".button-next",
          prevEl: ".button-prev"
        }
      });
    },
    tryNow() {
      let link =
        "http://internal.pisx.com:8013/TundraViewer/dist/professional/index.html#../../Models/二级减速器/asm-jiansuqi.asm.piv";
      window.open(link, "_blank");
    },
    handleClose() {
      this.dialogVisible = false;
    },
    getImagePath(imageModule) {
      return imageModule.default || imageModule;
    },
    goFile() {
      this.loading = true;
      this.$axios
        .get("http://internal.pisx.com:8012/api/filename")
        .then((res) => {
          // console.log("dddd" + res.data)
          this.tableData = res.data;
          console.log("testdddddd", this.tableData);
          this.loading = false;
          console.log(this.tableData);
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    downLoad(row) {
      this.$axios
        .get("http://internal.pisx.com:8012/api/filedownload", {
          params: {
            filename: row
          },
          responseType: "blob"
        })
        .then(({ data }) => {
          const blob = new Blob([data]);
          var a = document.createElement("a"); //创建一个<a></a>标签
          a.href = URL.createObjectURL(blob); // 将流文件写入a标签的href属性值
          a.download = row; //设置文件名
          a.style.display = "none"; // 障眼法藏起来a标签
          document.body.appendChild(a); // 将a标签追加到文档对象中
          a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
          a.remove(); // 一次性的，用完就删除a标签
        });
    },
    tabChange: function(e) {
      let tabid = e.target.dataset.id;
      this.tab = tabid;
      if (tabid === 1 || tabid === 2 || tabid === 3) {
        this.tab = tabid;
      } else {
        this.sort = tabid;
      }
      if (tabid == 2) {
        this.myTab == "viewer";
      }
      if (tabid == 3) {
        this.myTab == "wgm";
      }
      if (tabid == 4) {
        this.myTab == "capp";
      }
    },
    seeDownloadDetail(value) {
      this.$router
        .push({
          path: "/design",
          query: { view: value }
        })
        .catch((err) => err);
    }
  }
};
</script>

<style scoped lang="less">
.product_info {
  position: relative;
  font-size: 0;
}

.cappBox {
  padding: 10px;
  font-size: 24px;
  color: #333;
}

.product__box {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.product-light {
  width: 100%;
  background-color: #fff;
  padding: 50px 0;
  .light-content {
    display: flex;
    justify-content: space-between;
    .left {
      display: flex;
      flex-direction: column;
      margin-left: 200px;
      .title {
        color: rgba(0, 79, 146, 1);
        font-size: 36px;
      }
      .message {
        font-size: 28px;
        color: #333;
        width: 640px;
        margin-top: 100px;
      }
      .button-box {
        margin-top: 60px;
      }
    }
    .right {
      width: 50%;
      display: flex;
      justify-content: center;
      img {
        width: 630px;
        height: 492px;
      }
    }
  }
}

.product-features {
  width: 100%;
  background-color: #f0f7fa;
  .features-title {
    font-size: 36px;
    color: rgba(0, 79, 146, 1);
    text-align: center;
    padding: 50px 0;
  }

  .features-box {
    display: flex;
    flex-wrap: wrap;
    gap: 40px;
    justify-content: center;
    padding-bottom: 100px;
  }
  .features-item {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 400px;
    img {
      width: 120px;
      height: 120px;
    }
    .title {
      font-size: 24px;
      color: #333;
      margin-top: 20px;
    }
    .content {
      font-size: 18px;
      color: #333;
      margin-top: 20px;
      max-width: 400px;
      height: 52px;
    }
  }

  .batch-item {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 530px;
    img {
      width: 120px;
      height: 120px;
    }
    .title {
      font-size: 24px;
      color: #333;
      margin-top: 20px;
    }
    .content {
      font-size: 18px;
      color: #333;
      margin-top: 20px;
      max-width: 530px;
      height: 52px;
    }
  }

  .process-item {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 320px;
    img {
      width: 120px;
      height: 120px;
    }
    .title {
      font-size: 24px;
      color: #333;
      margin-top: 20px;
    }
    .content {
      font-size: 18px;
      color: #333;
      margin-top: 20px;
      max-width: 320px;
      height: 72px;
    }
  }
}

.download-content {
  display: flex;
  justify-content: center;
  align-items: center;
  .downLoad-text {
    font-size: 28px;
  }

  .downLoad-name {
    font-size: 16px;
  }
}

.name-wrapper {
  display: flex;
  .image {
    font-size: 28px;
    margin-right: 10px;
  }
}

.product-function {
  width: 100%;
  background-color: #fff;
  .function-title {
    font-size: 36px;
    color: rgba(0, 79, 146, 1);
    text-align: center;
    padding: 50px 0;
  }
  .main-title {
    font-size: 36px;
    color: rgba(0, 79, 146, 1);
    text-align: center;
    padding-top: 50px;
  }

  .main-content {
    display: flex;
    justify-content: center;
  }
  .function-content {
    display: flex;
    justify-content: center;
  }

  .swiper {
    width: 80%;
    height: 600px;
    margin: 0 auto;

    .swiper-slide {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 10px;
      .left {
        img {
          width: 70%;
          height: 70%;
        }
      }
      .right {
        display: flex;
        flex-direction: column;
        .right-box {
          width: 700px;
          margin-top: -50px;
          .title {
            font-size: 38px;
            color: #000;
            position: relative;
            img {
              width: 44px;
              margin-right: 8px;
            }
          }
          .title::after {
            content: "";
            position: absolute;
            width: 670px;
            height: 2px;
            background-color: #333;
            bottom: -10px;
            left: 0;
          }
          .text {
            font-size: 26px;
            color: #000;
            margin: 20px 0 80px 0;
          }
          .content {
            font-size: 20px;
            color: #000;
            margin-top: 10px;
            padding-right: 30px;
          }

          .button {
            margin-top: 20px;
          }
          .function {
            font-size: 20px;
            color: #000;
            margin-top: 50px;
            padding-right: 30px;
          }
        }

        .content-box {
          width: 700px;
          margin-top: -50px;
          padding-right: 140px;
          height: 400px;
          .title {
            font-size: 38px;
            color: #000;
            position: relative;
            img {
              width: 44px;
              margin-right: 8px;
            }
          }
          .title::after {
            content: "";
            position: absolute;
            width: 670px;
            height: 2px;
            background-color: #333;
            bottom: -10px;
            left: 0;
          }
          .text {
            font-size: 26px;
            color: #000;
            margin: 20px 0 80px 0;
          }
          .content {
            font-size: 20px;
            color: #000;
            margin-top: 10px;
          }
        }
      }
    }

    .swiper-pagination-fraction {
      font-size: 18px;
    }

    .function-bottons {
      display: flex;
      .button-next,
      .button-prev {
        position: absolute;
        top: 50px;
        right: 10px;
        font-size: 30px;
        color: #000;
        cursor: pointer;
      }
      .button-prev {
        margin-right: 30px;
      }
      .button-next {
        margin-left: 30px;
      }
    }
  }
}

.product-value {
  width: 100%;
  background-color: #f0f7fa;
  .value-title {
    font-size: 36px;
    color: rgba(0, 79, 146, 1);
    text-align: center;
    padding: 50px 0;
  }

  .value-content {
    padding-bottom: 50px;
    .value-box {
      display: flex;
      padding-bottom: 20px;
      width: 50%;
      margin: 0 auto;
      .left {
        margin-right: 50px;
        img {
          width: 100px;
          height: 100px;
        }
      }
      .right {
        .content {
          font-size: 18px;
          color: #333;
          margin-top: 20px;
          max-width: 800px;
        }
      }
    }
  }
}
</style>
